<app-header></app-header>

<div style="display: flex; flex-direction: column; align-items: center;">
  <div style="text-align: center; margin-bottom: -6.5rem;">
    <span class="reportTitle">{{ reportTitle }}</span>
  </div>
  <div style="min-width: 100%; display: inline-grid;">
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 0;">
      <div style="font-weight: bold; display: flex; flex-direction: column; align-items: flex-start;">
        <div>
          <app-date-range-picker [dateRangeForm]="dateRangeForm"
            (dateChange)="getReleaseReport(dateRangeForm.value.start, dateRangeForm.value.end)"
            (dateClear)="clearDates()" >
          </app-date-range-picker>
        </div>
      </div>
      <div style="font-weight: bold; display: flex; align-items: center;">
        <mat-form-field appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput type="text" [(ngModel)]="searchTerm" (ngModelChange)="applySearchFilter()"
            placeholder="Search releases"
            title="Search releases"
            [attr.aria-label]="'Search releases'">
          @if (searchTerm) {
            <button matSuffix mat-icon-button aria-label="Clear search" (click)="searchTerm=''; applySearchFilter()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    </div>
    <div style="display: flex; align-items: center;">
      <div class="button-wrapper">
        <button mat-raised-button class="button" (click)="copyReleases()">Copy</button>
      </div>
      <div class="button-wrapper link-wrapper">
        <a mat-raised-button class="button link-button" [href]="downloadHref" download="Release Report.csv"
          (click)="exportCsv()">
          CSV
        </a>
      </div>
      <div class="button-wrapper">
        <button mat-raised-button class="button" (click)="exportPdf(false)">PDF</button>
      </div>
      <div class="button-wrapper">
        <button mat-raised-button class="button" (click)="exportPdf(true)">Print</button>
      </div>
    </div>
    <div class="table-container-wrapper">
      <table #releasesTable mat-table [dataSource]="dataSource" multiTemplateDataRows matSort aria-describedby="releases">
        <ng-container matColumnDef="select">
          <th mat-header-cell class="header-row" style="width: 5px;" *matHeaderCellDef>
            <mat-checkbox (change)="selectAllRows()" [checked]="allRowsSelected"
              [indeterminate]="selection.hasValue() && !allRowsSelected">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>
        @for (column of columns; track column) {
          <ng-container [matColumnDef]="column.columnDef">
            <th mat-header-cell class="header-row" *matHeaderCellDef mat-sort-header>
            {{ column.header }}</th>
            <td mat-cell *matCellDef="let release">
              @if (column.columnDef !== 'uatState') {
                {{ column.cell(release) }}
              } @else {
                {{ column.cell(release) }}
              }
            </td>
          </ng-container>
        }
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let release" [attr.colspan]="columns.length + 1">
            <div class="release-detail-container" [@detailExpand]="release === expandedRow ? 'expanded' : 'collapsed'">
              <div class="release-detail">
                <div class="title-container"><span class="detail-title">Source Branch</span>
                <div class="detail-text"> {{release.branch}} </div>
              </div> <br />
              <div class="title-container"><span class="detail-title">Area Path</span>
              <div class="detail-text"> {{release.areaPath}} </div>
            </div> <br />
            <div class="title-container"><span class="detail-title">UAT</span>
            <div class="detail-text"> {{release.uatCompletedBy}} </div>
          </div> <br />
          <div class="title-container"><span class="detail-title">Release Link</span>
          <div class="detail-text"> <a style="text-decoration: underline" target="_blank"
          href="">{{release.releaseLink}}</a> </div>
        </div> <br />
        <div class="title-container"><span class="detail-title">Feature</span>
        <div class="detail-text"> <a style="text-decoration: underline" target="_blank"
        href="{{release.featureLink}}" rel="noopener"> {{release.featureId}}</a> </div>
      </div><br />
      <div class="title-container"><span class="detail-title">Epic</span>
      <div class="detail-text"> <a style="text-decoration: underline" target="_blank"
      href="{{release.epicLink}}" rel="noopener"> {{release.epicId}}</a> </div>
    </div>
  </div>
  <div class="release-detail">
    <div class="title-container"><span class="detail-title">Iteration Path</span>
    <div class="detail-text"> {{release.iterationPath}}</div>
  </div> <br />
  <div class="title-container"><span class="detail-title">QAT</span>
  <div class="detail-text"> {{release.qaCompletedBy}}</div>
</div> <br />
<div class="title-container"><span class="detail-title">Assigned To</span>
<div class="detail-text"> {{release.assignedTo}}</div>
</div> <br />
<div class="title-container"><span class="detail-title">Commit</span>
<div class="detail-text"> {{release.commitId}} </div>
</div> <br />
<div class="title-container"><span class="detail-title">Feature Business Value</span>
<div class="detail-text"> {{release.featureBusinessValue}}</div>
</div> <br />
<div class="title-container"><span class="detail-title">Epic Business Value</span>
<div class="detail-text"> {{release.epicBusinessValue}}</div>
</div>
</div>
</div>
</td>
</ng-container>
<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
<tr #tableRow mat-row *matRowDef="let release; columns: displayedColumns;" style="height: 40px;"
  class="release-row clickable" [class.expanded-release]="expandedRow === release" (click)="toggleRow(release)">
</tr>
<tr mat-row *matRowDef="let release; columns: ['expandedDetail']" class="release-detail-row"></tr>
</table>
</div>
<mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" showFirstLastButtons aria-label="Select page">
</mat-paginator>
</div>
